export default __webpack_public_path__ + "static/media/xsushi-sign-small.ee0a8de1.png";